// @flow

import * as React from 'react';

import { Button, Footer, Page, PageContainer, Panel, genRuby } from '@sonyged/ext-proc';

import { type FinishedRound, type FutureRound, History, type NewRound, Round } from './domain/Round';
import { PizzaIngredientIcon } from './icons/PizzaIngredientIcon';
import { Stars } from './Stars';
import PizzaCustomerIcon from './icons/PizzaCustomerIcon';
import PizzaStoreLogo from '../../../../assets/images/pages/top/img_theme_pizza@3x.png';

type Props = {
  history: FinishedRound[],
  current?: NewRound,
  future: FutureRound[],
  onNext: () => void,
  showResult: FinishedRound => void,
};

const noop = () => {};

class PizzaStatsView extends React.Component<Props> {
  componentDidMount() {
    const currentCard = document.getElementById('current-day');
    if (currentCard) currentCard.scrollIntoView(false);
  }

  render() {
    return (
      <div className="pizza-inner-view pizza-stats-view tertiary100-bg-color">
        <Page.normal>
          <PageContainer.normal>
            <div className="header">
              <div className="left" />

              <div className="center">
                <img src={PizzaStoreLogo} />
              </div>

              <div className="right">
                <div>
                  <div>
                    <span className="proc-pizzaTotal-title gray100-color">{genRuby('[合計|ごうけい]')}</span>
                  </div>
                  <div>
                    <span className="proc-pizzaTotal-amount gray100-color">
                      {History.totalSale(this.props.history)}
                    </span>{' '}
                    <span className="proc-pizzaTotal-yen proc-small-font gray100-color">円</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="content" id="proc-card-list">
              {this.props.history.map((round, i) => {
                const customerRatings = Round.ratings(round);
                return (
                  <Panel.horizontal
                    key={i}
                    className="proc-card proc-pizzaCard"
                    onClick={() => this.props.showResult(round)}
                  >
                    <div className="left">
                      <span className="proc-pizzaCard-title">{round.name}</span>
                      <div>
                        {customerRatings[0] && (
                          <div className="proc-pizzaCard--rating">
                            <PizzaCustomerIcon
                              talking={false}
                              onRequestToTalk={noop}
                              customer={customerRatings[0].customer}
                            />
                            <Stars satisfactionScore={customerRatings[0].rating} />
                          </div>
                        )}
                        {customerRatings[1] && (
                          <div className="proc-pizzaCard--rating">
                            <PizzaCustomerIcon
                              talking={false}
                              onRequestToTalk={noop}
                              customer={customerRatings[1].customer}
                            />
                            <Stars satisfactionScore={customerRatings[1].rating} />
                          </div>
                        )}
                        {customerRatings[2] && (
                          <div className="proc-pizzaCard--rating">
                            <PizzaCustomerIcon
                              talking={false}
                              onRequestToTalk={noop}
                              customer={customerRatings[2].customer}
                            />
                            <Stars satisfactionScore={customerRatings[2].rating} />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="right">
                      <span>
                        <span className="proc-pizzaCard-amount gray100-color">{Round.sale(round)}</span>{' '}
                        <span className="proc-pizzaCard-yen gray100-color">円</span>
                      </span>
                      <div className="proc-pizzaCard--ingredient">
                        <PizzaIngredientIcon ingredient={round.pizza.crust} />
                        <PizzaIngredientIcon ingredient={round.pizza.sauce} />
                        {round.pizza.toppings.map((topping, i) => {
                          return topping && <PizzaIngredientIcon key={i} ingredient={topping} />;
                        })}
                      </div>
                    </div>
                  </Panel.horizontal>
                );
              })}
              {this.props.current && (
                <React.Fragment>
                  <Panel.horizontal
                    className="proc-card proc-pizzaCard proc-hover proc-button-se"
                    onClick={this.props.onNext}
                  >
                    <div className="left">
                      <span className="proc-pizzaCard-title">{this.props.current.name}</span>
                      <div>
                        {this.props.current.customers[0] && (
                          <PizzaCustomerIcon
                            talking={false}
                            onRequestToTalk={noop}
                            customer={this.props.current.customers[0]}
                          />
                        )}
                        {this.props.current.customers[1] && (
                          <PizzaCustomerIcon
                            talking={false}
                            onRequestToTalk={noop}
                            customer={this.props.current.customers[1]}
                          />
                        )}
                        {this.props.current.customers[2] && (
                          <PizzaCustomerIcon
                            talking={false}
                            onRequestToTalk={noop}
                            customer={this.props.current.customers[2]}
                          />
                        )}
                      </div>
                    </div>
                    <div className="right" />
                  </Panel.horizontal>
                  <div id="current-day" style={{ height: 0 }} />
                </React.Fragment>
              )}

              {this.props.future.map((round, i) => {
                return (
                  <Panel.horizontal key={i} className="proc-card proc-pizzaCard disabled">
                    <div className="left">
                      <span className="proc-pizzaCard-title">{round.name}</span>
                    </div>
                  </Panel.horizontal>
                );
              })}
            </div>
          </PageContainer.normal>
        </Page.normal>
        <Footer.normal className="white-bg-color">
          <Button.attention onClick={this.props.onNext}>つぎへ</Button.attention>
        </Footer.normal>
      </div>
    );
  }
}

export default PizzaStatsView;
